import * as React from 'react';
import { FaFacebookF } from 'react-icons/fa';
// eslint-disable-next-line import/extensions
import { useLogin, useGraphAPI } from 'react-facebook/dist/cjs/index.js';
import { isReactNativeWebView } from '../../../utils/isReactNativeWebView';
import { redirectFacebookLogin } from '../../../utils/providerLogin';
import { BtnBrand, BtnContent, BtnIcon, BtnPrefix, SocialBtn } from '../SocialIconButton/styles';

function useFacebookLogin(onFacebookCompleted) {
  const { login } = useLogin();
  const { fetch: fetchProfile } = useGraphAPI({
    path: '/me',
    params: { fields: 'id,name,email' },
    autoFetch: false,
  });

  return React.useCallback(async () => {
    try {
      const response = await login({ scope: 'public_profile,email' });
      if (response?.status !== 'connected') {
        return;
      }

      const { accessToken, userID } = response.authResponse;
      const profile = await fetchProfile();

      onFacebookCompleted({
        profile: {
          id: userID || profile?.id,
          name: profile?.name,
          email: profile?.email,
        },
        tokenDetail: {
          accessToken,
          userID,
        },
      });
    } catch (e) {
      console.log('Facebook login error', e);
    }
  }, [fetchProfile, login, onFacebookCompleted]);
}

export function FacebookSignInButton({
  onFacebookCompleted,
  prefix = 'Entrar com',
  overlay = false,
}) {
  const inWebView = isReactNativeWebView();
  const handleClick = useFacebookLogin(onFacebookCompleted);

  const onClick = () => {
    if (inWebView) {
      redirectFacebookLogin();
      return;
    }
    handleClick();
  };

  if (overlay) {
    return (
      <SocialBtn
        type="button"
        onClick={onClick}
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 0.001,
          zIndex: 2,
          border: 'none',
          background: 'transparent',
        }}
        aria-label="Entrar com Facebook"
      />
    );
  }

  return (
    <SocialBtn type="button" onClick={onClick}>
      <BtnContent>
        <BtnPrefix>{prefix}</BtnPrefix>
        <BtnBrand color="#1877f2">Facebook</BtnBrand>
      </BtnContent>
      <BtnIcon>
        <FaFacebookF color="#1877f2" size={20} />
      </BtnIcon>
    </SocialBtn>
  );
}
